import React from 'react'

interface AdSlotProps {
  placementId: number
}

const AdSlot: React.FC<AdSlotProps> = ({ placementId }) => {
  // Não adicionar estilos no placeholder (regra da Ezoic)
  return <div id={`ezoic-pub-ad-placeholder-${placementId}`} />
}

export default AdSlot
